function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M419,824.2h125.5v-22.7c0-116.1,33.4-217.9,100.3-305.3v-59.6H367.9l-13.4,88.3h199.7C470.9,611.8,425.9,711.5,419,824.2z M933.7,168c-5-11.9-12.1-22.4-21.3-31.6c-9.2-8.4-19.7-15.3-31.6-20.7c-11.9-5.4-24.3-8-37.3-8h-49.4V10h-97.7v97.7H303.5V10h-97.7v97.7h-49.4c-13,0-25.5,2.7-37.3,8c-11.9,5.4-22.4,12.3-31.6,20.7c-8.4,9.2-15.3,19.7-20.7,31.6c-5.4,11.9-8,24.7-8,38.5v685.9c0,13.8,2.5,26.6,7.5,38.5c5,11.9,12.1,22,21.3,30.4c9.2,9.2,19.7,16.3,31.6,21.3c11.9,5,24.3,7.5,37.3,7.5h687c13,0,25.5-2.5,37.3-7.5c11.9-5,22.4-12.1,31.6-21.3c9.2-8.4,16.3-18.6,21.3-30.4c5-11.9,7.5-24.7,7.5-38.5V206.5C941.2,192.7,938.7,179.9,933.7,168z M843.5,892.3h-687V353.5h687V892.3z"
}));

function SvgHeaderWeekly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderWeekly);
export default __webpack_public_path__ + "static/media/header-weekly.96f0b9c3.svg";
export { ForwardRef as ReactComponent };